var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowPayment = function SvgArrowPayment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.109 3C9.78 3 8.988 4.481 9.725 5.587L14 12l-4.275 6.413C8.988 19.519 9.78 21 11.109 21c.556 0 1.076-.278 1.385-.741l4.766-7.15a2 2 0 0 0 0-2.219l-4.766-7.15A1.666 1.666 0 0 0 11.109 3z"
  })));
};
export default SvgArrowPayment;